<ion-header
  class="ion-no-border"
  [ngClass]="isTouch ? 'ion-header-modal-tablet' : 'ion-header-modal-desktop'"
>
  <ion-toolbar>
    <ion-buttons *ngIf="isTouch === false" slot="end">
      <ion-button data-cy="close-modal-btn" (click)="dismiss()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label id="invoice-download">{{
      'i18n.payments.invoiceDownload.title' | translate
    }}</ion-label>
    <ion-text aria-labelledby="invoice-download">{{
      'i18n.payments.invoiceDownload.description' | translate
    }}</ion-text>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-radio-group [(ngModel)]="selectedFormat">
      <ion-item
        *ngFor="let option of downloadOptions"
        [attr.data-cy]="'download-format-' + (option.format | lowercase)"
      >
        <ion-radio
          labelPlacement="start"
          aria-labelledby="download-option"
          mode="ios"
          slot="end"
          value="{{ option.format }}"
        >
          {{ option.title | translate }}
          <ion-label class="ion-label-helpText">
            {{ option.helpText | translate }}
          </ion-label>
        </ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-modal-btn"
        class="usf-outline-green-button"
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="download-modal-btn"
        [ngClass]="
          !selectedFormat ? 'usf-fill-disabled-button' : 'usf-fill-green-button'
        "
        (click)="download()"
      >
        {{ 'i18n.common.download' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
